import userAgent from './UserAgent'

/* uuid 생성 */
function generateUID () {
  function s4 () {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

/* device 활용 검사 */
function checkMobileDevice () {
  var mobileKeyWords = ['Android', 'iPhone', 'iPod', 'BlackBerry', 'Windows CE', 'SAMSUNG', 'LG', 'MOT', 'SonyEricsson']
  for (var info in mobileKeyWords) {
    if (navigator.userAgent.match(mobileKeyWords[info]) != null) {
      return true
    }
  }
  return false
}

function getUserAgent (ua, option) {
  return userAgent(ua || window.navigator.userAgent, option)
}

var utils = {}
utils.generateUID = generateUID
utils.checkMobileDevice = checkMobileDevice
utils.getUserAgent = getUserAgent

export default utils



// WEBPACK FOOTER //
// ./src/_fdp/utils/index.js